import styled from "styled-components";
import { MenuButton } from "@szhsin/react-menu";

export const IconStyled = styled.i`
  width: 30px;
`;

export const RoundedMenuButton = styled(MenuButton)`
  border-radius: 25%;
  background-color: #f8f9fa;
  padding: 8px;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  &:hover {
    background-color: #e9ecef;
  }
`;
